import { type ValueOf } from '@models/helpers/custom'

export const PaymentMethods = {
  CARD: 'card',
  CARD_TRANSFER: 'card_transfer',
  C2C: 'c2c',
  PHONE_TRANSFER: 'phone_transfer',
  BANK_TRANSFER: 'bank_transfer',
  OPEN_BANKING: 'open_banking',
  UPI: 'upi',
  CASH: 'cash',
  PIX: 'pix',
  VIRTUAL_ACCOUNT: 'virtual_account',
  QRIS: 'qris',
  IMPS: 'imps',
  PAYTM: 'paytm',
  PHONE_PE: 'phone_pe',
  NEFT: 'neft',
  RTGS: 'rtgs',
  NAGAD: 'nagad',
  BKASH: 'bkash',
  ROCKET: 'rocket',
  WEBPAY: 'webpay',
  HAVALE: 'havale',
  PAPARA: 'papara',
  PAYFIX: 'payfix',
  DCB: 'dcb',
  EASY_PAISA: 'easy_paisa',
  JAZZ_CASH: 'jazz_cash',
  EWALLET: 'ewallet',
  APPLE_PAY: 'apple_pay',
  GOOGLE_PAY: 'google_pay',
  YANDEX_PAY: 'yandex_pay',
  CRYPTO: 'crypto',
  INTERAC: 'interac',
  PROMPTPAY: 'promptpay',
  TRUEMONEY: 'truemoney'
} as const

export type PaymentMethodType = ValueOf<typeof PaymentMethods>
export type PaymentMethodOptionsType = {
  title: string;
  logo: string;
}
export type PaymentMethodMapType = Record<PaymentMethodType,PaymentMethodOptionsType>
